'use client'

import classNames from 'classnames'
import { Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isMobile?: boolean
}

const AdvertisingHeroText = ({ isMobile = false }: Props) => {
  const translate = useTranslate('advertising.hero')

  return (
    <div className={`advertising__${isMobile ? 'mobile-' : ''}hero--text`}>
      <Spacer size={isMobile ? 'x2-large' : 'x5-large'} />
      <Text as="h1" type="heading" width="parent">
        <span
          className={classNames('c-text--responsive-large-heading', !isMobile && 'c-text--inverse')}
        >
          {translate('title')}
        </span>
      </Text>
      <Spacer size="x2-large" />
      <Text as="span" html width="parent">
        <span className={classNames(!isMobile && 'c-text--inverse')}>
          <span className="advertising__hero--description">{translate('description')}</span>
        </span>
      </Text>
      <Spacer size={isMobile ? 'x2-large' : 'x5-large'} />
    </div>
  )
}

export default AdvertisingHeroText
